import { Component, OnInit, Inject } from '@angular/core';
import { TravelLiquidationCancelComponent } from '../travel-liquidation-cancel/travel-liquidation-cancel.component';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Travel } from 'src/app/models/travel';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { TravelLiquiditionService } from '../../services/travel-liquidition/travel-liquidition.service';
import { liquidationUrl, itineraryLQUrl, BOOKINGTYPE, PURPOSE } from 'src/app/modules/shared/common/api';
import { User } from 'src/app/models/user';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { ItineraryDetailsComponent } from 'src/app/modules/shared/components/itinerary-details/itinerary-details.component';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { TravelItineraryViewComponent } from 'src/app/modules/shared/components/travel-itinerary-view/travel-itinerary-view.component';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';
import { ConfirmationMessageComponent } from 'src/app/modules/shared/components/confirmation-message/confirmation-message.component';

@Component({
  selector: 'app-travel-liquidation-view',
  templateUrl: './travel-liquidation-view.component.html',
  styleUrls: ['./travel-liquidation-view.component.scss']
})
export class TravelLiquidationViewComponent implements OnInit {

  travel: Travel;
  user: User;
  formGroup: FormGroup;
  loading:boolean = false;
  isNoResult:boolean = false;
  isOther:boolean = false;
  show:boolean = false;
  isCharged:boolean = false;
  isCurrency:boolean = false;
  successMessage: String = '';
  total = 0;
  mealTotal = 0;
  transportFee = 0;
  totalCashAdvance = 0;
  selectedIndex = 0;
  currency_category = 0;
  charge_category = 0;
  msg="";
  res:any;

  option =  {
    btnOk:'Yes',
    btnCancel: 'Cancel',
  }

  employeeDetail = [];

  dialogConfig:any;
  summaryDetail:any;
  detail:any;
  departmentList = JSON.parse(localStorage.getItem('department'));
  positionList = JSON.parse(localStorage.getItem('position'));
  objectKeys = Object.keys;
  expensesList:any;
  
  travelOption = ["Individual","Group"];
  purposeOption = PURPOSE;
  natureOption = ["Inbound","Outbound"];

  currencyOption = [
    {id:1,name:"PHP"},
    {id:2,name:"USD"},
    {id:3,name:"Others"}
  ];
  chargeOption = [
    {id:1,name:"Rose Pharmacy"},
    {id:2,name:"DF"},
    {id:3,name:"Supplier"},
    {id:4,name:"RRHI"},
    {id:5,name:"Southstar Drug"}
  ];
  bookedOption = BOOKINGTYPE;
  billOption = ["Store Support Center","Requestor"];

  province = [{origin:''},{destination: ''}];
  city = [{city:''},{city: ''}];
  barangay = [{barangay:'' },{barangay: ''}];
 
  pipe = new DatePipe('en-US');

  constructor(
    public dialogRef: MatDialogRef<TravelLiquidationViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public liquidationService: TravelLiquiditionService,
    private formBuilder: FormBuilder,
    public travelService: TravelService,
    public functionService: FunctionsService,
    public auth: AuthService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.travel = new Travel(this.data.res);
    this.user = new User(this.auth.getAuthUser());
    this.detail = this.data.res;
    this.formGroup = this.formBuilder.group({
      date_filed:['',null],
      itinerary_date: ['',null],
      travel_request: ['',null],
      travel_request_id: ['',null],
      travel_request_type: ['',null],
      employee_id: ['',null],
      employee_name: ['',null],
      booking_type: ['',null],
      complete_name:['',null],
      employee_id_no: ['',null],
      position: ['',null],
      department: ['',null],
      area_covered: ['',null],
      payroll_acct_no: ['',null],
      travel_type: ['',null],
      copy_date: ['',null],
      purpose: ['',null],
      location: ['',null],
      nature: ['',null],
      inclusive_date_from: ['',null],
      inclusive_date_to: ['',null],
      representation:['',null],
      miscellaneous:['',null],
      currency: ['',null],
      amount: ['',null],
      charged_to: ['',null],
      booked_by: ['',null],
      bill_to: ['',null],
      is_draft: ['',null],
      accommodation_cost: ['',null],
      currency_category: ['',null],
      charged_to_category: ['',null],
      travel_itinerary_details:['',null],
      is_lunch:['',null],
      is_dinner:['',null],
      is_breakfast: ['',null],
      meal:['',null],
      per_diem:['',null],
      cash_advance_no:['',null],
      cash_advance_id:['',null],
      cash_for_reimbursement: ['',null],
      cash_return: ['',null],
      actual_cash_return:['',null],
      option:['',null],
      acknowledgement_receipt:['',null],
      date_received:['',null],
      travel_summary_id:['',null],
      misc_breakdown:['',null],
      others:['',null]
    });

    this.employeeDetail['level'] = this.travel.list.travel_request.level;
    this.employeeDetail['department'] = this.travel.list.travel_request.department;
    this.employeeDetail['area_assigned'] = this.travel.list.travel_request.area_assigned;

    this.formGroup.controls['misc_breakdown'].setValue(this.travel.misc_breakdown);
    this.travel.formGroup = this.formGroup;
    this.travel.disableForm();
    this.formGroup.controls['employee_id_no'].setValue(this.user.employee_id);
    this.formGroup.controls['travel_request_type'].setValue(this.travel.list.travel_request.travel_request_type);
    this.formGroup.controls['employee_id'].setValue(this.travel.list.travel_request.employee_id);
    this.formGroup.controls['employee_name'].setValue(this.travel.list.travel_request.employee_name);
    this.formGroup.controls['booking_type'].setValue(this.travel.list.travel_request.travel_summary.booking_type);
    this.formGroup.controls['area_covered'].setValue(this.travel.list.travel_request.area_covered);
    this.formGroup.controls['position'].setValue(this.travel.list.travel_request.position);
    this.formGroup.controls['department'].setValue(this.travel.list.travel_request.department);
    this.formGroup.controls['payroll_acct_no'].setValue(this.travel.list.travel_request.payroll_acct_no);
    this.formGroup.controls['booked_by'].setValue(this.travel.list.travel_request.travel_summary.booked_by);
    this.formGroup.controls['charged_to'].setValue(this.travel.list.travel_request.travel_summary.charged_to);
    this.formGroup.controls['currency'].setValue(this.travel.list.travel_request.travel_summary.currency_category_value);
    this.formGroup.controls['currency_category'].setValue(this.travel.list.travel_request.travel_summary.currency_category);
    this.formGroup.controls['charged_to_category'].setValue(this.travel.list.travel_request.travel_summary.charged_to_category);
    this.formGroup.controls['inclusive_date_from'].setValue(this.travel.list.travel_request.travel_summary.inclusive_date_from);
    this.formGroup.controls['inclusive_date_to'].setValue(this.travel.list.travel_request.travel_summary.inclusive_date_to);
    this.formGroup.controls['location'].setValue(this.travel.list.travel_request.travel_summary.location);
    this.formGroup.controls['nature'].setValue(this.travel.list.travel_request.travel_summary.nature);
    this.formGroup.controls['travel_type'].setValue(this.travel.list.travel_request.travel_summary.travel_type);
    this.formGroup.controls['cash_advance_id'].setValue(this.travel.list.travel_request.id);
    this.formGroup.controls['cash_for_reimbursement'].setValue(this.travel.list.cash_for_reimbursement);
    this.formGroup.controls['cash_return'].setValue(this.travel.list.cash_return);
    this.travel.itineraries = this.data.res.travel_request.travel_itineraries;
    this.totalCashAdvance =  this.data.res.travel_request.travel_itinerary_total.grand_total;
    
    let purposeOption = this.travel.list.travel_request.travel_summary.purpose.split("|");
    this.formGroup.controls['purpose'].setValue(purposeOption[0]);
    this.formGroup.controls['others'].setValue(this.travel.list.travel_request.travel_summary.others);
    this.data.isOther = false;
    if (purposeOption[0] == "OTHERS") {
      this.isOther = true;
      this.data.isOther = true;
      //this.formGroup.controls['others'].setValue(purposeOption[1]);
    }

    if (this.travel.list.travel_request.travel_summary.currency_category == 3) {
      this.isCurrency = true;
    }

    this.expensesList  = this.functionService.loopRangeDate(
      [
        this.travel.list.travel_request.travel_summary.inclusive_date_from,
        this.travel.list.travel_request.travel_summary.inclusive_date_to
      ],
      this.data.res.travel_request.travel_itineraries
    );

    
    if (this.data.res.actual_liquidation) {
      this.formGroup.controls['actual_cash_return'].disable();
      this.formGroup.controls['option'].disable();
      this.formGroup.controls['acknowledgement_receipt'].disable();
      this.formGroup.controls['date_received'].disable();
      this.formGroup.controls['actual_cash_return'].setValue(this.data.res.actual_liquidation.actual_cash_return);
      this.formGroup.controls['option'].setValue(this.data.res.actual_liquidation.option);
      this.formGroup.controls['acknowledgement_receipt'].setValue(this.data.res.actual_liquidation.acknowledgement_receipt);
      this.formGroup.controls['date_received'].setValue(this.pipe.transform(this.data.res.actual_liquidation.date_received,'yyyy-MM-dd'));
    }
   
    this.travel.getTotal();

    if (this.show) {
      this.formGroup.controls['cash_advance_id'].enable();
      this.formGroup.controls['travel_request_id'].enable();
      this.formGroup.controls['travel_summary_id'].enable();
      this.formGroup.controls['cash_advance_no'].enable();
      this.formGroup.controls['misc_breakdown'].enable();
      this.formGroup.controls['cash_for_reimbursement'].enable();
      this.formGroup.controls['cash_return'].enable();
    }

    this.formGroup.controls['is_draft'].enable();

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';

  }

  
  closeOnClick() {
    this.dialogRef.close(true);
    //this.deleteLiquidation();
  }

  deleteLiquidation() {
    let detail = [];
    if (this.travel.itineraries) {
      this.travel.itineraries.forEach(element => {
        if (element.travel_itinerary_liquidation) {
          detail.push(
            {
              itinerary_liquidation: (element.travel_itinerary_liquidation)? element.travel_itinerary_liquidation.id : null,
              itinerary_detail_liquidation: []
            }
          );
        }
        element.travel_itinerary_details.forEach((el,i) => {
          if (el.travel_itinerary_detail_liquidation) {
            detail[i].itinerary_detail_liquidation.push({id:el.travel_itinerary_detail_liquidation.id});
          }
        });
      }); 
    }
    if (detail.length > 0) {
      let data = {
        cash_advance_id: this.formGroup.controls['cash_advance_id'].value ,
        detail: detail,
        status: 'delete'
      }
      if (this.data.res.status_id != 3 || this.data.res.status_id != 2 || this.data.res.status_id != 1) {
        this.liquidationService.deleteliquidation(data).subscribe(res=>{
        });
      }

    }
  }
  
  save(isDraft:boolean){
    this.loading = true;

    this.formGroup.controls['cash_advance_id'].setValue(this.travel.list.travel_request.id);
    //this.formGroup.controls['travel_summary_id'].setValue(this.travel.list.travel_request.id);
    this.formGroup.controls['is_draft'].setValue(isDraft);
    this.formGroup.controls['travel_request_id'].setValue(this.travel.list.travel_request.id);
    this.formGroup.controls['travel_request'].setValue(this.travel.list.travel_request.travel_request);
    if(isDraft == true && this.formGroup.controls['cash_return'].value == ''){
      this.formGroup.controls['cash_return'].setValue(0)
    }
    this.liquidationService.updateLiquidation(this.travel.id,this.formGroup.value).subscribe(res=>{
      
      this.loading = false;
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: res['message']
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(true);
        }
      });
    },(err => {
      this.loading = false;
      
          this.travel.formGroup = this.formGroup;
          if (err.error.errors.mismatch) {
            var self = this;
            var emptyKey = 0;
            var continueLoop = true
    
            Object.keys(this.expensesList).forEach((element,i) => {
              if(this.expensesList[element].travel_itinerary_liquidation == 0) {
                if (continueLoop) {
                  emptyKey = i;
                  continueLoop = false;
                }
              }
            });

            this.openLiquidation(this.expensesList[Object.keys(this.expensesList)[emptyKey]],this.expensesList)
            setTimeout(function(){
              self.dialog.open(NotifyboxComponent, {
                disableClose:true,
                data: {
                  reload:false,
                  label:'Ok',
                  message: err.error.errors.mismatch[0]
                }
              });
            },800);
          }
          if (this.selectedIndex == 0) {
            this.selectedIndex = 1;
          }
          this.travel.setErrors(err.error.errors);
          this.travel.triggerErrors(err.error.errors);
    }));
  }

  saveAsDraft(){
    this.save(true);
  }

  close() {
    this.msg = "";
    this.res = null;
  }

  delete() {
    this.loading = true;
    let data = {
      status: 'Delete as Draft',

    }
    this.liquidationService.updateStatus(this.travel.id,data).subscribe(res=>{
      this.deleteLiquidation();
      this.loading = false;
      this.msg = "";
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: res['message']
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(true);
        }
      });
    },(err =>{
      this.loading = false;
    }));
  }

   /**
   * Delete Travel Request Data
   */
  deleteAsDraft() {
    let dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      disableClose:true,
      data: {
        message: "Are you sure you want to delete this draft?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.delete();
      }
    });
  }

  edit(){
    this.show = true;
    this.formGroup.controls['cash_advance_id'].enable();
    this.formGroup.controls['travel_request_id'].enable();
    this.formGroup.controls['travel_summary_id'].enable();
    this.formGroup.controls['cash_advance_no'].enable();
    this.formGroup.controls['misc_breakdown'].enable();
    this.formGroup.controls['cash_for_reimbursement'].enable();
    this.formGroup.controls['cash_return'].enable();
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/\d/); // '\d'
     return pattern.test(e.key);
  }

  /**
   * Number validation on input fields
   */  
  keypressValidateNumberDecimal(e) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g);
    const rgx = /^[0-9]*\.?[0-9]*$/;
    if ((e.key == '.' && e.target.value.includes('.')) || !pattern.test(e.key)) {
      return false;
    }
    return (e.target.value.match(rgx)) ? true : false;
  }

  /**
   * Number validation on input fields including negative symbol
   */
   cashReturnValidation(e){
    const rgx = /^[0-9,-]*\.?[0-9,-]*$/
    const pattern = new RegExp(/^[0-9,-]*\.?[0-9,-]*$/);
    if ((e.key == '.' && e.target.value.includes('.')) || !pattern.test(e.key)) {
      return false;
    }
    return (e.target.value.match(rgx)) ? true : false;
  }

  cancelCa(){
    this.dialogConfig.width = '800px';
    this.dialogConfig.data = {
      id: this.data.res.id
    }
    let dialogRef = this.dialog.open(TravelLiquidationCancelComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result != '') {
        this.travel.list.ca_status = result.ca_status;
        this.travel.status_id = result.status_id;
        this.dialogRef.close(true);
      }
    });
  }

  /**
   * Compute ATD
   * @param e 
   */
  atdCalculate(e) {
    // ATD = Total Cash Advance minus [Sum] of Total Actual Expense + Cash Return/Refund
    let atd = (this.totalCashAdvance - this.travel.totalLiquidation) + (+e.target.value);

    if(isNaN(atd)){
      this.formGroup.controls['cash_for_reimbursement'].setValue('')
    }
    else{
      this.formGroup.controls['cash_for_reimbursement'].setValue(atd.toFixed(2));
    }
  }

   /**
   * Open liquidaiton Detail
   */
  openLiquidation(res,detail){
    this.dialogConfig.width = '100vw';
    this.dialogConfig.panelClass = 'my-full-screen-dialog';
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.data = {
      module_id: this.travel.id,
      res,
      detail,
      cash_id: this.formGroup.controls['cash_advance_id'].value,
      mode:1,
      isEdit: this.show,
      url:itineraryLQUrl,
      status_id: this.data.res.status_id
    }
    let dialogRef = this.dialog.open(ItineraryDetailsComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.travel.clearTotal();
        this.travel.itineraries = result.travel_itineraries ? result.travel_itineraries : result.travel_request.travel_itineraries;
        const travel_summary = result.travel_summary ? result.travel_summary : result.travel_request.travel_summary;
        this.expensesList  = this.functionService.loopRangeDate(
          [travel_summary.inclusive_date_from,travel_summary.inclusive_date_to],
          this.travel.itineraries
        );
        this.travel.getTotal();
      }
    });
  }

  /**
   * Display Currency option
   * @param e = 3 get value for other currency
   */
  displayCurrency(e) {
    this.isCurrency = false;
    this.formGroup.get('currency_category').valueChanges.subscribe(value => { 
      if (value == 3) {
        this.isCurrency = true;
      }
    })
  }

  /**
   * Display other supplier
   * @param e  e = 3 get value for supplier
   */
  displayCharge(e) {
    this.isCharged = false;
    this.formGroup.get('charged_to_category').valueChanges.subscribe(value => { 
      if (value == 3) {
        this.isCharged = true;
      }
    })
  }

  /**
   * View itinerary Details Modal
   * @param res 
   */
  viewItinerary(res,i) {
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      res,
      list:this.travel.booking_details_list,
      mode: 1,
      displayEdit: false
    }
    let dialogRef = this.dialog.open(ItineraryDetailsComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  back(e){
    this.selectedIndex=e;
  }

  next(e){
    this.selectedIndex=e;
  }
}
